import * as THREE from "three";
import React, { useRef } from "react";

export default function Ring({
  vec1 = new THREE.Vector2(),
  vec2 = new THREE.Vector2(),
  ...props
}) {
  const group = useRef();
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh>
        <latheBufferGeometry
          attach="geometry"
          args={[
            [vec1.set(props.r1, 0), vec2.set(props.r2, 0)],
            props.res || 8,
          ]}
        />
        {props.children || (
          <meshStandardMaterial
            attach="material"
            color={props.color}
            side={THREE.DoubleSide}
          />
        )}
      </mesh>
    </group>
  );
}
